export const projectsData = [
  {
    title: "One More Street",
    tier: "featured",
    logo: "/images/onemorestreet/icon.svg",
    description:
      "A walking app for iPhone: walk or ride, your map fills in street by street, and the app suggests where to go next. Places you pass become stamps in city stamp books. Built end to end — the SwiftUI app, a Cloudflare backend, and a map pipeline from OpenStreetMap.",
    imageUrls: [
      "/images/onemorestreet/00-preview.mp4",
      "/images/onemorestreet/01-world.webp",
      "/images/onemorestreet/02-recording.webp",
      "/images/onemorestreet/03-summary.webp",
      "/images/onemorestreet/04-stamps.webp",
      "/images/onemorestreet/05-areas.webp",
      "/images/onemorestreet/06-compare.webp",
    ],
    date: "2026",
    link: {
      url: "https://onemorestreet.com/",
      title: "Website",
    },
    techStack: ["SwiftUI", "MapLibre", "Cloudflare Workers", "Durable Objects", "OpenStreetMap"],
  },
  {
    title: "Slipsee",
    appStoreUrl: "https://apps.apple.com/app/id6787081323",
    tier: "selected",
    description:
      "An iOS app that turns receipts into spending insights. Scan receipts, track category trends and price changes, and ask questions with answers grounded in your receipts. No bank login required.",
    imageUrls: [
      "/images/slipsee/01-home.jpg",
      "/images/slipsee/02-receipts.jpg",
      "/images/slipsee/04-chat.jpg",
    ],
    date: "2026",
    link: {
      url: "https://slipsee.app/",
      title: "Website",
    },
    techStack: ["SwiftUI", "TypeScript", "Cloudflare Workers"],
  },
  {
    title: "Birdex UI",
    tier: "selected",
    description:
      "An open-source, hand-drawn paper-&-crayon React Native design system — design tokens plus ~30 sketch-style components — extracted from my Birdex app. Ships with a runnable react-native-web gallery.",
    imageUrls: [
      "/images/birdex-ui/birdex-ui-1.png",
      "/images/birdex-ui/birdex-ui-2.png",
      "/images/birdex-ui/birdex-ui-3.png",
    ],
    date: "2026",
    link: {
      url: "https://github.com/xieweizhi/birdex-ui",
      title: "GitHub",
    },
    techStack: ["React Native", "TypeScript", "react-native-svg", "Design System"],
  },
  {
    title: "Mood Recall",
    tier: "selected",
    description:
      "A private journaling app that uses semantic search to surface past entries matching your current mood.",
    imageUrls: [
      "/images/mood-recall/screenshot-home.jpeg",
      "/images/mood-recall/screenshot-feed.jpeg",
      "/images/mood-recall/screenshot-details.jpeg",
    ],
    date: "2026",
    link: {
      url: "https://mood-recall.com",
      title: "Website",
    },
    techStack: ["SwiftUI", "SQLite", "FAISS", "Core ML"],
  },
  {
    title: "Nihongo Easy",
    tier: "selected",
    description:
      "A calm Japanese typing dojo with adaptive drills for Hiragana, Katakana, and JLPT vocabulary.",
    imageUrls: [
      "/images/nihongoeasy/nihongoeasy-0.jpg",
      "/images/nihongoeasy/nihongoeasy-1.jpg",
      "/images/nihongoeasy/nihongoeasy-2.jpg",
    ],
    date: "2025",
    link: {
      url: "https://www.nihongoeasy.com/",
      title: "Website",
    },
    techStack: ["React", "TypeScript"],
  },
  {
    title: "Calories AI",
    tier: "archive",
    description: "AI-assisted calorie tracker built with Expo and OpenAI. Archived before launch.",
    imageUrls: [
      "/images/calories-ai/calories-ai-1.png",
      "/images/calories-ai/calories-ai-2.png",
      "/images/calories-ai/calories-ai-4.png",
    ],
    date: "2025",
    techStack: ["React Native", "Expo", "OpenAI", "Firebase"],
  },
  {
    title: "JuicyPomo",
    layout: "wide",
    appStoreUrl: "https://apps.apple.com/us/app/juicypomo/id6504472667?platform=iphone",
    tier: "selected",
    description: "A minimalist Pomodoro timer for iPhone, focused on speed and restraint.",
    imageUrls: [
      "/images/pomo/pomo-0.webp",
      "/images/pomo/pomo-1.webp",
      "/images/pomo/pomo-2.webp",
      "/images/pomo/pomo-3.webp",
    ],
    date: "2024",
    link: {
      url: "https://apps.apple.com/us/app/juicypomo/id6504472667?platform=iphone",
      title: "App Store",
    },
    techStack: ["Swift", "SwiftUI"],
  },
  {
    title: "iBooks Anki",
    tier: "archive",
    description:
      "Turns Apple Books highlights into translated Anki flashcards automatically.",
    imageUrls: ["/images/ibooks-anki.jpg"],
    date: "2020",
    link: {
      url: "https://github.com/xieweizhi/ibooks_anki",
      title: "GitHub",
    },
    techStack: ["JavaScript", "Python"],
  },
  {
    title: "Tubi TV Flutter",
    tier: "archive",
    description:
      "A Flutter take on Tubi TV with video playback and the Tubi TV API.",
    imageUrls: [
      "/images/tubi-tv/0.jpg",
      "/images/tubi-tv/1.jpg",
      "/images/tubi-tv/2.jpg",
    ],
    date: "2019",
    link: {
      url: "https://github.com/xieweizhi/tubi_tv_flutter",
      title: "GitHub",
    },
    techStack: ["Flutter"],
  },
  {
    title: "Flutter Classic Kit",
    tier: "archive",
    description:
      "Retro Flutter UI components inspired by Windows 95, 98, and XP.",
    imageUrls: [
      "/images/classic-kit/image-0.png",
      "/images/classic-kit/image-1.png",
    ],
    date: "2019",
    link: {
      url: "https://github.com/xieweizhi/flutter_classic_kit",
      title: "GitHub",
    },
    techStack: ["Flutter"],
  },
];
